import { render, staticRenderFns } from "./TicketFilesField.vue?vue&type=template&id=6fedcb7e&scoped=true&lang=pug&"
import script from "./TicketFilesField.vue?vue&type=script&lang=js&"
export * from "./TicketFilesField.vue?vue&type=script&lang=js&"
import style0 from "./TicketFilesField.vue?vue&type=style&index=0&id=6fedcb7e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fedcb7e",
  null
  
)

/* custom blocks */
import block0 from "./TicketFilesField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports